import { Grid, Skeleton } from "@mui/material";
import React from "react";

const SkeletonLoader = () => {
  return (
    <Grid
      container
      sx={{
        p: { sm: 2 },
      }}
    >
      <Grid item xs={12} sm={4} sx={{ p: 3 }}>
        <Skeleton
          sx={{
            height: 270,
            width: "90%",
            borderRadius: 3,
          }}
          animation="wave"
          variant="rectangular"
        />
      </Grid>
      <Grid item xs={12} sm={7} sx={{ py: 3 }}>
        <Skeleton sx={{ height: 50, width: "30%" }} animation="wave" />
        <Skeleton sx={{ height: 151, width: "70%" }} animation="wave" />
        <Grid sx={{ display: "flex", gap: 5, alignItems: "center" }}>
          <Skeleton sx={{ height: 50, width: "10%" }} animation="wave" />
          <Skeleton sx={{ height: 50, width: "10%" }} animation="wave" />
          <Skeleton sx={{ height: 50, width: "10%" }} animation="wave" />
        </Grid>
      </Grid>
    </Grid>
  );
};

export default SkeletonLoader;
